import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitAdminNavPaywallRequestMutationVariables = Types.Exact<{
  source: Types.Scalars['String']['input'];
  business_type: Types.Scalars['String']['input'];
  role: Types.Scalars['String']['input'];
  website?: Types.InputMaybe<Types.Scalars['String']['input']>;
  notes?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SubmitAdminNavPaywallRequestMutation = { __typename?: 'mutation_root', submit_admin_nav_paywall_request?: { __typename?: 'SubmitAdminNavPaywallRequestOutput', success: boolean } | null };


export const SubmitAdminNavPaywallRequestDocument = gql`
    mutation submitAdminNavPaywallRequest($source: String!, $business_type: String!, $role: String!, $website: String, $notes: String) {
  submit_admin_nav_paywall_request(
    source: $source
    business_type: $business_type
    role: $role
    website: $website
    notes: $notes
  ) {
    success
  }
}
    `;
export type SubmitAdminNavPaywallRequestMutationFn = Apollo.MutationFunction<SubmitAdminNavPaywallRequestMutation, SubmitAdminNavPaywallRequestMutationVariables>;

/**
 * __useSubmitAdminNavPaywallRequestMutation__
 *
 * To run a mutation, you first call `useSubmitAdminNavPaywallRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAdminNavPaywallRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAdminNavPaywallRequestMutation, { data, loading, error }] = useSubmitAdminNavPaywallRequestMutation({
 *   variables: {
 *      source: // value for 'source'
 *      business_type: // value for 'business_type'
 *      role: // value for 'role'
 *      website: // value for 'website'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useSubmitAdminNavPaywallRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAdminNavPaywallRequestMutation, SubmitAdminNavPaywallRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAdminNavPaywallRequestMutation, SubmitAdminNavPaywallRequestMutationVariables>(SubmitAdminNavPaywallRequestDocument, options);
      }
export type SubmitAdminNavPaywallRequestMutationHookResult = ReturnType<typeof useSubmitAdminNavPaywallRequestMutation>;
export type SubmitAdminNavPaywallRequestMutationResult = Apollo.MutationResult<SubmitAdminNavPaywallRequestMutation>;
export type SubmitAdminNavPaywallRequestMutationOptions = Apollo.BaseMutationOptions<SubmitAdminNavPaywallRequestMutation, SubmitAdminNavPaywallRequestMutationVariables>;